// Marker that we can use to find invoice line items that are not associated
// with a trip so we can remove the trip from the upsert
export const INVOICE_LINE_ITEM_TRIP_ID_MARKER =
  'invoice-line-item-trip-id-marker';

// Id of the scrollable container that wraps the line item groups inside the
// invoice modal. Used to scroll a specific group into view within the modal
// (rather than scrolling the whole document).
export const INVOICE_LINE_ITEM_SCROLL_CONTAINER_ID =
  'invoice-line-item-scroll-container';
